import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";

export interface VariacoesHeaderProps {
  onGerarAutomaticamente: () => void;
  onAdicionar: () => void;
  onGerenciarAtributos: () => void;
}

export default function VariacoesHeader({
  onGerarAutomaticamente,
  onAdicionar,
  onGerenciarAtributos,
}: VariacoesHeaderProps) {
  return (
    <MDBox
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      mb={2}
    >
      <MDTypography variant="h5" fontWeight="medium">
        Variações do Produto
      </MDTypography>
      <MDBox display="flex" gap={1} flexWrap="wrap">
        <MDButton
          size="small"
          variant="outlined"
          color="dark"
          onClick={onGerarAutomaticamente}
        >
          <Icon sx={{ mr: 0.5 }}>auto_awesome</Icon>
          Gerar Automaticamente
        </MDButton>
        <MDButton
          size="small"
          variant="gradient"
          color="dark"
          onClick={onAdicionar}
        >
          <Icon sx={{ mr: 0.5 }}>add</Icon>
          Adicionar Variação
        </MDButton>
        <MDButton
          size="small"
          variant="outlined"
          color="dark"
          onClick={onGerenciarAtributos}
        >
          <Icon sx={{ mr: 0.5 }}>tune</Icon>
          Gerenciar Atributos
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
